export const createSumArray = (array) => {
    if (array && array.length) {
        return array.reduce((acumulator, current) => Number.isNaN(current) ? acumulator : acumulator + current)
    }
}